<cdx-card
	[padding]="padding"
	[cdxTrackImpression]="analyticsData"
	class="article">
	<a [href]="link" [target]="target" maybeExternal (click)="trackClick()">
		<div class="article-image">
			<img [src]="image" [alt]="imageAlt" />
		</div>
		<div class="article-content">
			<p class="article-type" *ngIf="type">{{ type }}</p>
			<h4 class="article-title">
				{{ title }}<cdx-svg-icon name="chevron-right" fill="dark" display="inline" size="extra-small"></cdx-svg-icon>
			</h4>
			<p class="article-text" *ngIf="text">{{ text }}</p>
		</div>
	</a>
</cdx-card>
